import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import { userRatingsRequest, userRatingsSuccess, userRatingsFailure } from '../reducers/userRatings';
import { API_LINK } from '../../constants';
import {selectedProgram, selectedProgramId, selectedContentId, selectedContent, selectedVersionId, getSelectedThinktool} from '../selectors'

const API = `${API_LINK}api/rating`;

function* userRatingAxios() {

  const state = yield select(fullState => fullState);

  const userId = state.loginReducer.user.isTeamLeader
    ? state.teamMembersFullReducer.selectedTeamMemberId
    : state.loginReducer.user.userId;
    const {
      token,
    } = state.loginReducer;

  const {
    userRating,
    userRatingComment,
    userRatingVersion,
  } = state.userProgramsFullReducer;
  const { selectedUserVersion } = state.userProgramsFullReducer;
  var comment = 'no comment'
  if(userRatingComment!=''){
     comment = userRatingComment
  }
  const response = yield call(() => {
    
  return axios({
    method: 'post',
    url: API,
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      Authorization: `Bearer ${token}`,
    },
   
    credentials: 'same-origin',
    data: {
      user_id: userId, 
      version_id: selectedVersionId(state), 
      rating: userRating, 
      comment: comment,
      rollout_id:selectedProgram(state).rolloutID,
      module_id:getSelectedThinktool(state).module_id,
      platform:'web'
    },
  });
});

  return response;
}

function* workerUserRatingSaga() {
  
  try {
    const response = yield call(userRatingAxios);
    const responseFromUserRating = response.data;

    yield put(userRatingsSuccess(responseFromUserRating));
    if (response.status === 500) {
      yield put(userRatingsFailure(responseFromUserRating));
    }
  } catch (error) {
    yield put(userRatingsFailure(error));
  }
}

export function* watcherUserRatingSaga() {
  yield takeLatest(userRatingsRequest().type, workerUserRatingSaga);
}
